<template>
  <v-app>
    <Navbar/>
    <v-content>
      <form @submit.prevent="editItem">
        <v-card>
          <v-container grid-list-sm class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 align-center justify-space-between>
                <v-layout align-center>
                  <v-text-field
                    prepend-icon="shopping_cart"
                    placeholder="Tuotteen Nimi"
                    required
                    v-model="item.name"
                  ></v-text-field>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-center justify-space-between>
                <v-layout align-center>
                  <v-text-field
                
                    prepend-icon="local_atm"
                    placeholder="Hinta"
               
                    v-model="item.taxprice"
                  ></v-text-field>
                </v-layout>
              </v-flex>
         
              <!-- <v-flex xs12>               
                <v-select
                    prepend-icon="shop_two"
                    v-bind:items="item_categories"
                    v-model="item.item_category"
                    label="Category"
                    item-text="category_name"
                    item-value="item_categories"
                    single-line
                ></v-select>
              </v-flex> -->
                 <v-flex xs12>               
                <v-select
                    prepend-icon="shop_two"
                    v-bind:items="campaigns"
                    v-model="item.campaign_id"
                    label="Valitse kampanja"
                    item-text="campaign_name"
                    
                    item-value="id"
                    single-line
                ></v-select>
              </v-flex>
              <!-- <v-flex xs12 align-center justify-space-between>               
                <h3>Upload Item Image</h3>
                <v-layout align-center>                                   
                  <input type="file" @change="uploadImage" /> 
                </v-layout>
                <v-progress-linear
                    :active="loading"
                    :indeterminate="loading"                   
                    color="primary"
                ></v-progress-linear>  
              </v-flex> -->
              <!-- <v-flex xs12>
                  <h3>Item Details</h3>
                  <div id="app">
                    <vue-editor v-model="item.details"></vue-editor>
                  </div>
                </v-flex> -->
                   <v-flex xs6>
                  <v-checkbox 
                    v-model="item.iscampaign" 
                    label="Alennustuotteet">
                  </v-checkbox>
                </v-flex>   
                <!-- <v-flex xs4>
                  <v-checkbox 
                    v-model="item.isfeatured" 
                    label="Suositeltu">
                  </v-checkbox>
                </v-flex>    -->
                  <v-flex xs6>
                  <v-checkbox 
                    v-model="item.isnew" 
                    label="Uusi Tuote">
                  </v-checkbox>
                </v-flex>   
                    <!-- <v-list-tile style="margin-top:10px">
                          <v-list-tile-content><b>Start Date</b></v-list-tile-content>
                          <v-flex xs12 lg8>
                            <v-menu
                              ref="menu4"
                              :close-on-content-click="false"
                              v-model="menu4"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="490px"
                              min-width="390px"
                            >
                            <v-text-field
                              slot="activator"
                              v-model="start_date"
                              placeholder="Date"
                              persistent-hint 
                            ></v-text-field>
                            <v-date-picker v-model="start_date" no-title @input="menu4 = false"></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-list-tile>
                      
                       <v-list-tile style="margin-top:10px">
                          <v-list-tile-content><b>End Date</b></v-list-tile-content>
                          <v-flex xs12 lg8>
                            <v-menu
                              ref="menu5"
                              :close-on-content-click="false"
                              v-model="menu5"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="490px"
                              min-width="390px"
                            >
                            <v-text-field
                              slot="activator"
                              v-model="end_date"
                              placeholder="Date"
                              persistent-hint 
                            ></v-text-field>
                            <v-date-picker v-model="end_date" no-title @input="menu5 = false"></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-list-tile> -->
                <v-flex xs12>
                  <v-btn type="submit" block class="main_color" dark>Muokata</v-btn>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card>
         <div class="text-center"> 
              <v-snackbar
                v-model="notreadySnackbar"
                :timeout="timeout"
              >              
                {{ pdfnotreadyText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
      </form>
    </v-content>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from "firebase";
  import moment from 'moment'
  import { VueEditor } from "vue2-editor";
  export default {
    name:'EditItem',
    components:{
      Navbar,VueEditor
    },
    data(){
      return{
        dialog:null,
        name:null,
        notreadySnackbar: false,
         pdfnotreadyText: 'valitse kampanja',
          snackbar:false,
        price:null,       
        item_category:'',
        campaign:'',
        image:null,
        details:null,
     //   isfeatured:null,
        iscampaign:false,
        isnew:false,
        total:null,
        timestamp:null,
        feedback:null,
        item_categories:[],
        campaigns:[],
        item:'',
        loading: null,
          start_date:this.start_date,
        end_date:this.end_date,
         menu4: false,
        menu5: false,
      }
    },
    watch: {
      loading (val) {
        if (!val) return
        setTimeout(() => (this.loading = false), 4000)
      },
    }, 
    methods:{
      editItem(){

        if(this.item.iscampaign==true)
        {
          if(this.item.campaign_id=='')
          {
          this.notreadySnackbar = true  
          return;
          }
        }

        if(this.item.iscampaign==null|| this.item.iscampaign=='')
        this.item.campaign_id=null;


        var db = firebase.firestore();
        if(this.item.name){
          let ref = db.collection('products_short2').doc(this.$route.params.id);
            ref.update({
            // name:this.item.name,
            // price:this.item.price,           
           // item_category:this.item.item_category, 
            campaign_id:this.item.campaign_id,
         //   image:this.item.image,
       //     details:this.item.details,
     //       isfeatured:this.item.isfeatured,
             iscampaign:this.item.iscampaign,
               isnew:this.item.isnew,
               syncdate:moment().unix()
         //   total:parseFloat(this.item.price * this.item.quantity),
            // adding_date:moment().format('DD-MM-YYYY'),
            // created_month:moment().format('MM-YYYY'),
            // created_year:moment().format('YYYY'),             
          })
          this.item_name=null
          this.price=null
          this.quantity=null
          this.customer=null

          let ref2=db.collection('settings').doc('lastsync2');
          ref2.update({
            syncdate:moment().unix()
          })



        }
        this.$router.push({ name: 'Items'})
      },
      uploadImage(e){
        if(e.target.files[0]){
          
            let file = e.target.files[0];
      
            var storageRef = firebase.storage().ref('products/'+ Math.random() + '_'  + file.name);
      
            let uploadTask  = storageRef.put(file);
      
            uploadTask.on('state_changed', (snapshot) => {
              
            }, (error) => {
              // Handle unsuccessful uploads
            }, () => {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                this.item.image=downloadURL;
                console.log(downloadURL);                
              });
            });
          this.loading = true  
        }   
      }
    },
    created(){
      // Show data of a specific Items
      var db = firebase.firestore();
      db.collection("products_short2").doc(this.$route.params.id).onSnapshot(doc =>{
          this.item = doc.data()
          this.item.id = doc.id

          if(this.item.isnew==null)
          this.item.isnew=false;

               if(this.item.iscampaign==null)
          this.item.iscampaign=false;

              if(this.item.campaign_id==null)
          this.item.campaign_id="";

    })

    // // Show All Categories
    // var db = firebase.firestore();
    // let ref = db.collection('item_categories').orderBy('timestamp', 'desc')

    // ref.onSnapshot(snapshot => {
    //   snapshot.docChanges().forEach(change => {
    //     if(change.type == 'added'){
    //       let doc = change.doc
    //       this.item_categories.push({
    //         id:doc.id,
    //         category_name:doc.data().category_name
    //       })
    //     }
    //   })
    // })

      // Show All Campaigns
    let ref2 = db.collection('campaigns').orderBy('timestamp', 'desc')

    ref2.onSnapshot(snapshot => {
      snapshot.docChanges().forEach(change => {
        if(change.type == 'added'){
          let doc = change.doc
          this.campaigns.push({
            id:doc.id,
            campaign_name:doc.data().campaign_name
          })
        }
      })
    })


    }
  }
</script>

<style>
.primary--text {
    color: #345B2C !important;
    caret-color: #345B2C !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/stock/EditItem.vue